<div>
  <div class="mx-auto" *ngIf="loadingRelator">
    <div class="d-flex justify-content-center">
      <strong>{{ inputMessageModal }}</strong>
    </div>
    <div class="d-flex justify-content-center">
      <strong>Espere un momento mientras se carga la información ...
        <div class="spinner-border" role="status"></div>
      </strong>
    </div>
  </div>
  <div *ngIf="!loadingRelator">
    <div id="divMensajeError" class="alert alert-danger" role="alert" style="display: none;">
      {{mensajeError}}
    </div>
    <div class="row">
      <div class="col-9">
      </div>
      <div class="col-3">
        <input type="text" [ngModel]="searchT" [class]="'form-control'" placeholder="Buscar..."
          (keyup)="changeSearch($event)">
      </div>
    </div>
    <table datatable [dtTrigger]="dtTriggerRelator" class="table table-striped table-responsive">
      <thead>
        <tr>
          <th>Acciones</th>
          <th>Nombre Relator</th>
          <th>Ejecutores</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let relator of relatorMantenedor | paginate: {itemsPerPage : 10, currentPage: pageActualRelator}">
          <td class="td-centered">
            <span (click)="onCreateRelator(relatorModal,'Editar', relator)" [ngbTooltip]="'Editar'">
              <img [src]="'assets/icons/pencil.svg'" />
            </span>
            <span (click)="openDeleteModalRelator(confirmationModal, relator.relator)" [ngbTooltip]="'Eliminar'">
              <img [src]="'assets/icons/trashcan.svg'" />
            </span>
          </td>
          <td class="td-centered">{{relator.relator.relatorDescription}}</td>
          <td class="td-centered td-truncated">{{getLabelEjecutores(relator.ejecutores)}}</td>
        </tr>
      </tbody>
    </table>
    <pagination-controls (pageChange)="pageActualRelator = $event" class="pagination"></pagination-controls>
  </div>
</div>

<ng-template #relatorModal let-modal>
  <app-relator-modal [modalCategoria]="modal" [ejecutores]="allEjecutores" [relatorEjecutores]="relatorEjecutores"
    [mode]="creationMode" [categoria]="relatorSelected" (createEdit)="refreshRelatorCreateOrUpdate($event)">
  </app-relator-modal>
</ng-template>
<ng-template #confirmationModal let-modal>
  <app-confirmation-modal [modal]="modal" [tittle]="confirmationModalTittle" [message]="confirmationModalMessage"
    [hasComment]="confirmationModalHasComment" [hasOptions]="confirmationModalHasOptions"
    [isCommentObligatory]="confirmationModalisCommentObligatory" [optionLabel]="confirmationModalOptionLabel"
    [options]="confirmationModalOptions" (accept)="confirmationModalAccept($event.comment, $event.option)">
  </app-confirmation-modal>
</ng-template>